export default __webpack_public_path__ + "static/media/copy.47f512d5.svg";